import { render, staticRenderFns } from "./PersonDemo.vue?vue&type=template&id=5bc6cda1"
import script from "./PersonDemo.vue?vue&type=script&lang=js"
export * from "./PersonDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports